/** Human label for RogerDoc section keys; value stays the raw key. */
export function formatSectionDropdownLabel(sectionKey: string): string {
  if (!sectionKey) return '';
  // ASCII underscore (U+005F) and fullwidth low line (U+FF3F); collapse runs to one space
  return sectionKey
    .replace(/[\u005F\uFF3F]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
